import type {SVGProps} from 'react';

export const MapIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={45}
		height={45}
		fill="none"
		viewBox="0 0 45 45"
		{...props}
	>
		<g filter="url(#a)">
			<rect width={36.176} height={36.176} x={4} y={0.351} fill="#fff" rx={10.853} />
			<path
				fill="#01679D"
				fillRule="evenodd"
				d="M22.313 9.395c4.114 0 7.461 3.373 7.461 7.518 0 5.097-5.839 10.118-7.461 10.118-1.623 0-7.461-5.021-7.461-10.117 0-4.146 3.347-7.519 7.46-7.519Zm0 1.357c-3.366 0-6.105 2.765-6.105 6.161 0 4.323 5.087 8.533 6.105 8.758 1.018-.226 6.105-4.436 6.105-8.758 0-3.396-2.739-6.161-6.105-6.161Zm0 3.165c1.621 0 2.94 1.319 2.94 2.94a2.942 2.942 0 0 1-2.94 2.939 2.942 2.942 0 0 1-2.939-2.939 2.943 2.943 0 0 1 2.94-2.94Zm0 1.357c-.872 0-1.582.71-1.582 1.583a1.584 1.584 0 0 0 3.165 0c0-.873-.71-1.583-1.582-1.583Z"
				clipRule="evenodd"
			/>
		</g>
		<defs>
			<filter
				id="a"
				width={44.176}
				height={44.176}
				x={0}
				y={0.351}
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
			>
				<feFlood floodOpacity={0} result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy={4} />
				<feGaussianBlur stdDeviation={2} />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_713_7201" />
				<feBlend in="SourceGraphic" in2="effect1_dropShadow_713_7201" result="shape" />
			</filter>
		</defs>
	</svg>
);
